module.exports = __webpack_public_path__ + "img/richter-min.72287942.png";